import { joinPath } from '@framework/ui';

const window$: any = window;

function normalizePublicPath(path?: string | null) {
  if (!path) return '/';

  let normalizedPath = path;
  if (!normalizedPath.endsWith('/')) normalizedPath += '/';
  if (!normalizedPath.startsWith('/')) normalizedPath = `/${normalizedPath}`;
  return normalizedPath;
}

export const appConfig = {
  /**
   * Sempre nel formato `/cartella/` oppure `/`
   */
  publicPath: normalizePublicPath(
    window$.PUBLIC_PATH || process.env.PUBLIC_PATH,
  ),
  apiBaseUrl: (window$.API_BASE_URL || process.env.API_BASE_URL) as
    | string
    | undefined,
  rootNavigationPath: (window$.ROOT_NAVIGATION_PATH ||
    process.env.ROOT_NAVIGATION_PATH) as string,
  mockLogin: process.env.MOCK_LOGIN === 'true',
};

/**
 * Permette di utilizzare URL importati da webpack anche in caso di
 * sottocartelle.
 */
export function resolvePublicPath(path: string) {
  // Non c'è bisogno di aggiungere `publicPath` perché ci pensa webpack
  // nel momento in cui si importa un file (es. `require('./file.png')`)
  return joinPath([path]);
}

/**
 * Aggiunge il `publicPath` alla risorsa.
 */
export function addPublicPath(path: string) {
  return joinPath([appConfig.publicPath, path]);
}

/**
 * Permette di ottenere il link alle API risolvendo sottocartelle e URL
 * delle API.
 */
export function resolveApiPath(path: string) {
  return joinPath([appConfig.apiBaseUrl, path]);
}
